module.exports = __webpack_public_path__ + "img/icon-triste.57801c25.png";